import { render, staticRenderFns } from "./PendingProducts.vue?vue&type=template&id=489af61c"
import script from "./PendingProducts.vue?vue&type=script&lang=js"
export * from "./PendingProducts.vue?vue&type=script&lang=js"
import style0 from "./PendingProducts.vue?vue&type=style&index=0&id=489af61c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports